const constants = {
    BASE_API_URL:'https://mailera.amygbdemos.in/api',
    LISTENER_API_URL: 'https://mapper.amygbdemos.in/api'
}
export default constants;




// WEBPACK FOOTER //
// ./src/constants.js